  <div class="ruleset-modal">
    <div class="modal-header">
      <div>
        <h2>Add Ruleset</h2>
        <p>Create a ruleset by configuring proctoring rules.</p>
      </div>

      <button class="close-btn" (click)="close()">
        <span>
            <i class="bi bi-x-lg"></i>
        </span>
      </button>
    </div>

    <form [formGroup]="rulesetForm">
    <div class="section">
      <h3>Ruleset Details</h3>

      <div class="form-grid">
        <div class="form-group">
          <label>Ruleset Name<span>*</span></label>
          <input
            type="text"
            placeholder="Enter ruleset name"
            formControlName="name"
          />
                <small
                  class="text-danger smaller-text"
                  *ngIf="rulesetForm.get('name')?.touched && rulesetForm.get('name')?.errors?.['required']">
                  Ruleset name is required.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="rulesetForm.get('name')?.touched && rulesetForm.get('name')?.errors?.['minLength']">
                  Ruleset name must contain at least 3 characters.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="rulesetForm.get('name')?.touched && rulesetForm.get('name')?.errors?.['maxLength']">
                  Ruleset name cannot exceed 100 characters.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="rulesetForm.get('name')?.touched && rulesetForm.get('name')?.errors?.['trimSpaces']">
                  Leading and trailing spaces are not allowed.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="rulesetForm.get('name')?.touched && rulesetForm.get('name')?.errors?.['whitespace']">
                  Ruleset name cannot be empty.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="rulesetForm.get('name')?.touched && rulesetForm.get('name')?.errors?.['invalidCharacters']">
                  Invalid characters are not allowed.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="rulesetForm.get('name')?.touched && rulesetForm.get('name')?.errors?.['firstCharacter']">
                  Ruleset name cannot start with a special character.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="rulesetForm.get('name')?.touched && rulesetForm.get('name')?.errors?.['duplicate']">
                  Ruleset name already exists.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="rulesetForm.get('name')?.touched && rulesetForm.get('name')?.errors?.['html']">
                  Invalid input detected.
                </small>
        </div>

        <div class="form-group">
          <label>Purpose<span>*</span></label>
          <input
            type="text"
            placeholder="Enter purpose"
            formControlName="description"
          />
            <small
            class="text-danger smaller-text"
            *ngIf="rulesetForm.get('description')?.touched && rulesetForm.get('description')?.errors?.['required']">
            Purpose  is required.
            </small>
            <small
            class="smaller-text text-danger"
            *ngIf="rulesetForm.get('description')?.touched && rulesetForm.get('description')?.errors?.['maxLength']">
            Description cannot exceed 500 characters.
          </small>

          <small
            class="smaller-text text-danger"
            *ngIf="rulesetForm.get('description')?.touched && rulesetForm.get('description')?.errors?.['trimSpaces']">
            Extra spaces will be removed.
          </small>

          <small
            class="smaller-text text-danger"
            *ngIf="rulesetForm.get('description')?.touched && rulesetForm.get('description')?.errors?.['whitespace']">
            Please enter a valid description.
          </small>

          <small
            class="smaller-text text-danger"
            *ngIf="rulesetForm.get('description')?.touched && rulesetForm.get('description')?.errors?.['invalidCharacters']">
            Invalid characters entered.
          </small>

          <small
            class="smaller-text text-danger"
            *ngIf="rulesetForm.get('description')?.touched && rulesetForm.get('description')?.errors?.['html']">
            Invalid input detected.
          </small>
        </div>

        <div class="form-group full-width">
          <label>Proctoring Configuration</label>

          <div class="config-dropdown">

            <div class="config-input" (click)="dropdownConfigOpen = !dropdownConfigOpen; dropdownOpen = false; rulesetForm.get('configurationId')?.markAsTouched()"
             [class.invalid]="rulesetForm.get('configurationId')?.invalid &&
              rulesetForm.get('configurationId')?.touched">
              {{
                selectedConfigurationName || 'Select configuration...'
              }}
              <i class="bi bi-chevron-down"></i>
            </div>

            <div class="config-menu" *ngIf="dropdownConfigOpen">

          <div class="config-list">
            <ng-container *ngFor="let config of configData">
            <div
              class="config-item"
              *ngIf="!config.isDefault"
              (click)="selectConfiguration(config)"
            >
            <span [matTooltip]="config.name">
              {{ (config.name || '').length > 80 ? ((config.name || '') | slice:0:80) + '...' : config.name || '-' }}
             </span> 
            </div>
            </ng-container>
          </div>

          <div class="config-pagination">
            <button
              type="button"
              (click)="previousPage()"
              [disabled]="currentPage === 1">
              <i class="bi bi-chevron-left"></i>
            </button>

            <span>{{ currentPage }} / {{ totalPages }}</span>

            <button
              type="button"
              (click)="nextPage()"
              [disabled]="currentPage === totalPages">
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
          </div>
            <small
    class="smaller-text text-danger"
    *ngIf="rulesetForm.get('configurationId')?.hasError('required') && rulesetForm.get('configurationId')?.touched">
     Please select a configuration from the dropdown or set as default.
  </small>
        </div>
      </div>

      <div class="default-card">
        <div class="default-content">
          <h4>Set as default</h4>

          <p>Make this the organization default ruleset.</p>
        </div>

        <div
          class="toggle"
          [class.active]="isDefault"
          (click)="toggleDefault()"
        >
          <span></span>
        </div>
      </div> 
    </div>
    </form>

    <div class="section mt-3">
      <div class="rule-header-row">
        <h3>Rule Configuration<span>*</span></h3>

        <div class="rule-action-area">
          <div class="rule-select-wrapper">
            <div class="rule-input" (click)="dropdownOpen = !dropdownOpen; dropdownConfigOpen = false">
              <span>
                {{
                  selectedRules.length
                    ? selectedRules.length + " rules selected"
                    : "Select rules to add..."
                }}
              </span>

              <span class="arrow"> ▼ </span>
            </div>

            <div class="rule-dropdown" *ngIf="dropdownOpen">
              <div class="rule-item" *ngFor="let rule of availableRules" [class.disabled-rule]="isRuleAdded(rule)">
                <input
                  type="checkbox"
                  [checked]="isSelected(rule) || isRuleAdded(rule)"
                  [disabled]="isRuleAdded(rule)"
                  (change)="toggleRule(rule)"
                />

                <span [class.text-muted]="isRuleAdded(rule)">
                  {{ rule.name }}
                </span>
              </div>

              <button class="done-btn" (click)="dropdownOpen = false">
                Done
              </button>
            </div>
          </div>

          <button class="add-btn ms-3 " (click)="addSelectedRules()">
            + Add Rule
          </button>
        </div>
      </div>
    </div>

  
    <div class="table-wrapper" *ngIf="addedRules.length > 0">
      <table>
        <thead>
          <tr>
            <th>Rule</th>
            <th>Description</th>
            <th>Severity</th>
            <th>Debounce (S)</th>
            <th>Window (S)</th>
            <th>Threshold</th>
            <th>Escalation</th>
            <th>Snapshot</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let rule of addedRules; let i = index">
            <td>{{ rule.ruleName  }}</td>

            <td>
              {{ rule.description }}
            </td>

            <td class="severity-cell" style="vertical-align: top;">
              <select class="severity-select" [(ngModel)]="rule.severity" #severity="ngModel" required [ngModelOptions]="{standalone: true}">
                <option value="" disabled>Select Severity</option>
                <option value="LOW">Low</option>
                <option value="MEDIUM">Medium</option>
                <option value="HIGH">High</option>
                <option value="CRITICAL">Critical</option>
              </select>
              <small *ngIf="severity.invalid" class="text-danger smaller-text mt-1 d-block" style="text-align: left;">
                 <span *ngIf="severity.errors?.['required']">Select Severity.</span>
              </small>
            </td>

            <td class="number-cell" style="vertical-align: top;">
              <input
                class="number-input"
                type="number"
                [(ngModel)]="rule.debounceSeconds"
                min="1"
                max="300"
                required
                pattern="^[0-9]+$"
                #debounce="ngModel"
                [ngModelOptions]="{standalone: true}"
                (keypress)="preventNonNumericalInput($event)"
              />
              <small *ngIf="debounce.invalid" class="error-msg text-danger smaller-text mt-1 d-block">
                <span *ngIf="debounce.errors?.['required']">Debounce is required.</span>
                <span *ngIf="debounce.errors?.['min']">Debounce must be at least 1.</span>
                <span *ngIf="debounce.errors?.['max']">Debounce cannot exceed 300.</span>
                <span *ngIf="debounce.errors?.['pattern'] && !debounce.errors?.['min']">Debounce must be a whole number.</span>
              </small>
            </td>

            <td class="number-cell" style="vertical-align: top;">
              <input
                class="number-input"
                type="number"
                [(ngModel)]="rule.thresholdWindowSeconds"
                [min]="rule.debounceSeconds > 5 ? rule.debounceSeconds : 5"
                max="600"
                required
                pattern="^[0-9]+$"
                #window="ngModel"
                [ngModelOptions]="{standalone: true}"
                (keypress)="preventNonNumericalInput($event)"
              />
              <small *ngIf="window.invalid || rule.thresholdWindowSeconds < 5 || rule.thresholdWindowSeconds > 600 || rule.thresholdWindowSeconds < rule.debounceSeconds" class="error-msg text-danger smaller-text mt-1 d-block">
                 <span *ngIf="window.errors?.['required']">Window is required.</span>
                 <span *ngIf="window.errors?.['min']">Window must be at least {{ rule.debounceSeconds > 5 ? rule.debounceSeconds : 5 }}.</span>
                 <span *ngIf="window.errors?.['max']">Window cannot exceed 600.</span>
                 <span *ngIf="window.errors?.['pattern'] && !window.errors?.['min']">Window must be a whole number.</span>
              </small>
            </td>

            <td class="number-cell" style="vertical-align: top;">
              <input
                class="number-input"
                type="number"
                [(ngModel)]="rule.thresholdCount"
                min="1"
                [max]="rule.thresholdWindowSeconds < 100 ? rule.thresholdWindowSeconds : 100"
                required
                pattern="^[0-9]+$"
                #threshold="ngModel"
                [ngModelOptions]="{standalone: true}"
                (keypress)="preventNonNumericalInput($event)"
              />
              <small *ngIf="threshold.invalid || rule.thresholdCount > 100" class="error-msg text-danger smaller-text mt-1 d-block">
                 <span *ngIf="threshold.errors?.['required']">Threshold is required.</span>
                 <span *ngIf="threshold.errors?.['min']">Threshold must be at least 1.</span>
                 <span *ngIf="threshold.errors?.['max'] || rule.thresholdCount > 100">Threshold cannot exceed {{ rule.thresholdWindowSeconds < 100 ? rule.thresholdWindowSeconds : 100 }}.</span>
                 <span *ngIf="threshold.errors?.['pattern'] && !threshold.errors?.['min']">Threshold must be a whole number.</span>
              </small>
            </td>

              <td class="severity-cell" style="vertical-align: top;">
              <select class="severity-select" [(ngModel)]="rule.escalationAction" #escalation="ngModel" required [ngModelOptions]="{standalone: true}">
                <option value="" disabled>Select Escalation</option>
                <option value="WARN">Warn</option>
                <option value="CANCEL">Cancel</option>
                <option value="BLOCK">Block</option>
              </select>
              <small *ngIf="escalation.invalid" class="text-danger smaller-text mt-1 d-block" style="text-align: left;">
                 <span *ngIf="escalation.errors?.['required']">Select an Escalation level.</span>
              </small>
            </td>
            

            <td class="snapshot-cell">
              <div
                class="toggle small"
                [class.active]="rule.captureSnapshot"
                (click)="rule.captureSnapshot = !rule.captureSnapshot"
              >
                <span></span>
              </div>
            </td>

            <td class="action-cell">
              <button class="delete" (click)="removeRule(i)">
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

      <div class="empty-state" *ngIf="addedRules.length === 0">
        <h6>No rules added</h6>
        <p>Select rules and click <b>Add Rule</b> to configure them.</p>
    </div>

    <div class="modal-footer">
      <button class="cancel" (click)="close()">Cancel</button>

      <button class="save" (click)="saveRuleset()" [disabled]="rulesetForm.invalid || !isAddedRulesValid">Save Ruleset</button>
    </div>
  </div>